import { Merge } from '@shared/types/type.utils';
import { CustomValidators, CustomValidatorTypes } from '@shared/utils/validators.utils';

/**
 * Interface for the error dictionary
 */
interface ErrorDictionary {
  [key: string]: ErrorFactory;
}

/**
 * Interface for individual errors in error dictionary.
 * Optionally takes an object as an argument from the thrown validation error,
 * which it can use to build more informative error messages
 */
type ErrorFactory = (errorObject: { [key: string]: string }) => string;

type CustomErrorType = Merge<{ [key in keyof typeof CustomValidators]: ErrorFactory },
  {
    [key in CustomValidatorTypes]: ErrorFactory
  }>

/**
 * Dictionary of the default errors used by the control-errors directive to map1
 * validator key to error message
 */
export const defaultFormErrors: ErrorDictionary = {
  default: () => $localize`Неверный формат`,
  required: () => $localize`Обязательно для заполнения`,
  requiredTrue: () => $localize`Должно быть выбрано`,
  email: () => $localize`Неверный формат адреса`,
  minlength: ({ requiredLength, actualLength }) =>
    $localize`Минимум ${requiredLength} символов, вы ввели ${actualLength}`,
  maxlength: ({ requiredLength, actualLength }) =>
    $localize`Допускается максимум ${requiredLength} символов, но вы ввели ${actualLength}`,
  min: ({ min, actual }) => $localize`Минимальное значение ${min}, вы ввели ${actual}`,
  max: ({ max, actual }) => $localize`Максимальное значение ${max}, вы ввели ${actual}`,
  pattern: ({ requiredPattern, actualValue }) =>
    $localize`${actualValue} не соответствует шаблону ${requiredPattern}`,
};

export const customFormErrors: CustomErrorType = {
  onlyNumber: () => $localize`Значение должно быть числом`,
  date: () => $localize`Неправильный формат даты`,
  dateRequired: () => $localize`Неправильный формат даты`,
  dateString: () => $localize`Неправильный формат даты`,
  time: () => $localize`Введите время в формате чч:мм`,
  duplicate: ({ item, params }) => item + $localize` с таким ${params || 'названием'} уже существует`,
  // custom: ({ message }) => message
  messageRequired: () => $localize`Вы не ввели сообщение`,
  fileRequired: () => $localize`Добавьте файл(ы)`,
  [CustomValidatorTypes.messageOrFileRequired]: () => $localize`Введите сообщние или добавьте файл(ы)`,
  [CustomValidatorTypes.customMessage]: ({ message }) => message,
  [CustomValidatorTypes.requireNonSpace]: () => $localize`Текст не может содержать только пробелы`,
  [CustomValidatorTypes.loginFormat]: () =>
    $localize`Логин может содержать только латинские буквы "A-z", цифры 0-9 и знаки "-", ".", "@"`,
  [CustomValidatorTypes.lampNumberFormat]: ({ message }) => message,
  [CustomValidatorTypes.deviceSerialNumber]: ({ message }) => message
};

/**
 * We export the interfaces so end users can easily strongly type their own custom error dictionary
 */
export { ErrorDictionary, ErrorFactory };
